import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const PDPAffirm = props => {
  const variantBySelectedOption = props.product.variants.find(
    (v) =>
      JSON.stringify(v.selectedOptions) ===
      JSON.stringify(props.product.variantBySelectedOptions.selectedOptions),
  );
  const [currentVariant, setCurrentVariant] = 
  useState(variantBySelectedOption);

  const [currentVariantPrice, setCurrentVariantPrice] = 
    useState( parseFloat(variantBySelectedOption?.price?.amount) * 100 );
  const affirmThreshold = 
    props.affirmThreshold ? props.affirmThreshold * 100 : 0;


  useEffect(() => window.affirm?.ui.refresh && window.affirm.ui.refresh(), 
    [currentVariantPrice]);  

  useEffect(() => {
    setCurrentVariantPrice( parseFloat(currentVariant?.price?.amount) * 100 );
  }, [currentVariant]);

  const handleCurrentVariantUpdated = (e) => {
    setCurrentVariant(props.product.variants.find(
      (v) =>
        JSON.stringify(v.id) ===
        JSON.stringify(e.detail.currentVariant),
    ));
  };

  useEffect(() => {
    document.addEventListener("currentVariantUpdated", handleCurrentVariantUpdated);
    return () => window.removeEventListener('resize', handleCurrentVariantUpdated);
  }, []);
  
  return (
    <div>
      {(currentVariantPrice > affirmThreshold) &&
      <div className="pdp-affirm-container">
        <p
            className="affirm-as-low-as"
            data-amount={currentVariantPrice}
            data-affirm-type="logo"
            data-page-type="product"
            data-affirm-color="blue"
            style="font-size: 11px; color: #404040; text-align: center;">
        </p>
      </div>}
    </div>
  )
}

export default PDPAffirm;